import ChevronDownIcon from "@heroicons/react/24/outline/ChevronDownIcon";
import React, { FC } from "react";

import {
  ButtonBase,
  ListItemText,
  MenuItem,
  MenuList,
  Popover,
  SvgIcon,
  Theme,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { common } from "@mui/material/colors";
import { alpha } from "@mui/material/styles";

import { usePopover } from "../../hooks/use-popover";
import { purple } from "../../theme/colors";

export const DocsDropdown: FC = () => {
  const popover = usePopover<HTMLButtonElement>();
  const mdDown = useMediaQuery((theme: Theme) => theme.breakpoints.down("lg"));
  const smDown = useMediaQuery((theme: Theme) => theme.breakpoints.down("sm"));

  const goto = (url: string) => {
    popover.handleClose();
    window.open(url, "_blank");
  };

  return (
    <>
      <ButtonBase
        onClick={popover.handleOpen}
        ref={popover.anchorRef}
        sx={{
          backgroundColor: alpha(purple.light, 0.45),
          borderColor: purple.dark,
          borderRadius: 1,
          display: "flex",
          px: smDown ? "4px" : mdDown ? "6px" : "12px",
          py: smDown ? "4px" : "6px",
          "&:hover": {
            backgroundColor: alpha(common.white, 0.21),
          },
          width: "100%",
        }}
      >
        <Typography
          component="span"
          color="inherit"
          sx={{
            fontSize: smDown ? 13 : 14,
            lineHeight: "24px",
          }}
          onClick={() =>
            goto(
              "https://www.pomerium.com/docs?utm_source=zero&utm_medium=console&utm_campaign=docs-tracking",
            )
          }
        >
          Docs
        </Typography>
        <SvgIcon
          color="action"
          fontSize="small"
          sx={{ ml: smDown ? 0.25 : mdDown ? 0.5 : 3 }}
        >
          <ChevronDownIcon />
        </SvgIcon>
      </ButtonBase>
      <Popover
        anchorEl={popover.anchorRef.current}
        anchorOrigin={{
          horizontal: "left",
          vertical: "bottom",
        }}
        disableScrollLock
        onClose={popover.handleClose}
        open={popover.open}
        slotProps={{
          paper: {
            sx: {
              p: 1,
              minWidth: 210,
            },
          },
        }}
      >
        <MenuList dense sx={{ p: 0 }}>
          <MenuItem
            onClick={() =>
              goto(
                "https://www.pomerium.com/docs/courses?utm_source=zero&utm_medium=console&utm_campaign=docs-tracking",
              )
            }
            sx={{ borderRadius: 1 }}
          >
            <ListItemText>Courses</ListItemText>
          </MenuItem>
          <MenuItem
            onClick={() =>
              goto(
                "https://www.pomerium.com/docs/guides?utm_source=zero&utm_medium=console&utm_campaign=docs-tracking",
              )
            }
            sx={{ borderRadius: 1 }}
          >
            <ListItemText>Guides</ListItemText>
          </MenuItem>
        </MenuList>
      </Popover>
    </>
  );
};
